import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import successImg from '../images/success.png'

const text = {
    es: {
        email: 'Email de empresa (*)',
        emailPlaceholder: 'Ingresa tu email de empresa ...',
        name: 'Nombre (*)',
        namePlaceholder: 'Ingresa tu primer nombre ...',
        lastName: 'Apellido (*)',
        lastNamePlaceholder: 'Ingresa tu apellido ...',
        webPage: 'Sitio web de tu empresa (*)',
        webPagePlaceholder: 'Ingresa la página web de tu empresa ...',
        phone: 'Código País y Teléfono Móvil (*)',
        phonePlaceholder: 'Ingresa tu teléfono móvil o WhatsApp (con código de país) ...',
        acceptEmailText: 'Acepto recibir información relevante por email',
        acceptWhatsAppText: 'Acepto recibir información relevante por WhatsApp',
        invalidEmail: 'El email ingresado no es válido',
        invalidName: 'El nombre no puede estar vacío',
        invalidLastName: 'El apellido no puede estar vacío',
        invalidWebPage: 'La página web de tu empresa no puede estar vacío',
        invalidPhone: 'El teléfono y el código país no pueden estar vacíos',
        invalidPhoneFormat: 'El teléfono debe tener el siguiente formato {format}',
        sentMessageTitle: 'Formulario enviado',
        sentMessageDescription: 'Nos contactaremos a la brevedad',
        close: 'Cerrar',
        send: 'Enviar',
        signUp: 'Registrarse'
    },
    en: {
        email: 'Company email (*)',
        emailPlaceholder: 'Please add your company email ...',
        name: 'First Name (*)',
        namePlaceholder: 'Please add your first name ...',
        lastName: 'Last Name (*)',
        lastNamePlaceholder: 'Please add your last name ...',
        webPage: 'Web Page (*)',
        webPagePlaceholder: 'Please add you web page ...',
        phone: 'Country Code and Mobile Phone (*)',
        phonePlaceholder: 'Please add your mobile phone number (with country code) ...',
        acceptEmailText: 'I want to get email notifications',
        acceptWhatsAppText: 'I want to get WhatsApp notifications',
        invalidEmail: 'Email not valid',
        invalidName: "First Name can't be empty",
        invalidLastName: "Last Name can't be empty",
        invalidWebPage: "Web Page can't be empty",
        invalidPhone: "Phone and country code can't be empty",
        invalidPhoneFormat: 'Phone must have the following format {format}',
        sentMessageTitle: 'Form sent',
        sentMessageDescription: 'We will be in touch soon!',
        close: 'Close',
        send: 'Send',
        signUp: 'Sign Up'
    }
}

function ContactForm ({ id, lang }) {
    const [messageSent, setMessageSent] = useState(false)

    const [formData, setFormData] = useState({
        companyEmail: '',
        firstName: '',
        lastName: '',
        companyURL: '',
        phone: '',
        acceptEmails: false,
        acceptWhatsApp: false
    })

    const [errors, setErrors] = useState({
        companyEmail: null,
        firstName: null,
        lastName: null,
        companyURL: null,
        phone: null
    })

    const [formMessage, sefFormMessage] = useState(null)

    const [countryCode, setCountryCode] = useState(null)
    const [phoneFormat, setPhoneFormat] = useState(null)

    // eslint-disable-next-line
    const validEmailRegex = RegExp(
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    )

    const url = 'https://8ysqz4kp36.execute-api.us-west-1.amazonaws.com/'

    const sendEmail = (emailTo, emailSubject, emailBody) => {
        const sentEmailUrl = `${url}EmailServer/`
        return fetch(sentEmailUrl, {
            method: 'post',
            mode: 'cors',
            credentials: 'omit',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                emailTo,
                emailSubject,
                emailBody
            })
        })
    }

    const validateFormField = (key, value) => {
        let errorValue
        switch (key) {
        case 'companyEmail':
            errorValue = validEmailRegex.test(value) ? null : text[lang].invalidEmail
            break
        case 'firstName':
            errorValue = value.length === 0 ? text[lang].invalidName : null
            break
        case 'lastName':
            errorValue = value.length === 0 ? text[lang].invalidLastName : null
            break
        case 'companyURL':
            errorValue = value.length === 0 ? text[lang].invalidWebPage : null
            break
        default:
            break
        }
        return errorValue
    }

    const validatePhoneField = (phone, format) => {
        if (!format || !phone) {
            return text[lang].invalidPhone
        }

        /*
        Remove validation because it's broken for some countries
        if (!phone.match(format.replace('+', '\\+').replace('(', '\\(').replace(')', '\\)'))) {
            return text[lang].invalidPhoneFormat.replace('{format}', format.replaceAll('.', '_ '))
        }
        */

        return null
    }

    const handleFormInput = (e) => {
        let errorValue = null
        errorValue = validateFormField(e.target.name, e.target.value)
        setErrors({
            ...errors,
            [e.target.name]: errorValue
        })
        if (e.target.name === 'acceptEmails' || e.target.name === 'acceptWhatsApp') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked
            })
        } else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            })
        }
    }

    const handleSubmit = () => {
        const companyEmailErrorValue = validateFormField('companyEmail', formData.companyEmail)
        const firstNameErrorValue = validateFormField('firstName', formData.firstName)
        const lastNameErrorValue = validateFormField('lastName', formData.lastName)
        const companyUrlErrorValue = validateFormField('companyURL', formData.companyURL)
        const phoneErrorValue = validatePhoneField(formData.phone, phoneFormat)

        if (
            !companyEmailErrorValue &&
            !firstNameErrorValue &&
            !lastNameErrorValue &&
            !companyUrlErrorValue &&
            !phoneErrorValue
        ) {
            setMessageSent(true)
            const emailSubject = `New lead from web page ${formData.companyURL}`
            const emailBody = formData
            sendEmail('info@optiwe.com', emailSubject, emailBody)
                .then(() =>
                    sefFormMessage(
                        'Thank you for your interest! We will contact you during the next 24hs.'
                    )
                )
                .catch(() => {
                    setMessageSent(false)
                    sefFormMessage(
                        'An error occurred while sending the form. Please contact us at info@optiwe.com'
                    )
                })
        } else {
            setMessageSent(false)
            setErrors({
                ...errors,
                companyEmail: companyEmailErrorValue,
                firstName: firstNameErrorValue,
                lastName: lastNameErrorValue,
                companyURL: companyUrlErrorValue,
                phone: phoneErrorValue
            })
        }
    }

    const phoneOnChange = (formattedPhone, country) => {
        let phone
        if (country.format) {
            setPhoneFormat(country.format)
        }

        if (country.dialCode && countryCode !== country.dialCode) {
            // In this case, the phone is only set with the country code to force the user
            // rewrite the phone number.
            phone = country.dialCode
            setCountryCode(country.dialCode)
        } else {
            phone = formattedPhone
        }

        const errorValue = validatePhoneField(formattedPhone, country.format)
        setErrors({
            ...errors,
            phone: errorValue
        })

        setFormData({
            ...formData,
            phone
        })
    }

    if (messageSent) {
        return (
            <div className="message-sent">
                <img src={successImg} alt="message sent" />
                <h2 className="ow-banner__title">{text[lang].sentMessageTitle}</h2>
                <p>{text[lang].sentMessageDescription}</p>
            </div>
        )
    }
    return (
        <div className="contact-form ow-contact-form--modal" key={id}>
            <div className="row">
                <div className="col-sm-12 pt-3">
                    <label htmlFor={`companyEmail${id}`} className="d-block">
                        {text[lang].email}
                    </label>
                    <input
                        id={`companyEmail${id}`}
                        type="text"
                        aria-label={text[lang].email}
                        placeholder={text[lang].emailPlaceholder}
                        value={formData.companyEmail}
                        name="companyEmail"
                        onChange={handleFormInput}
                    />
                    {errors.companyEmail && <span className="error">{errors.companyEmail}</span>}
                </div>
                <div className="col-sm-12 pt-3">
                    <label htmlFor={`firstName${id}`} className="d-block">
                        {text[lang].name}
                    </label>
                    <input
                        id={`firstName${id}`}
                        aria-label={text[lang].name}
                        type="text"
                        placeholder={text[lang].namePlaceholder}
                        value={formData.firstName}
                        name="firstName"
                        onChange={handleFormInput}
                    />
                    {errors.firstName && <span className="error">{errors.firstName}</span>}
                </div>
                <div className="col-sm-12 pt-3">
                    <label htmlFor={`lastName${id}`} className="d-block">
                        {text[lang].lastName}
                    </label>
                    <input
                        id={`lastName${id}`}
                        aria-label={text[lang].lastName}
                        type="text"
                        placeholder={text[lang].lastNamePlaceholder}
                        value={formData.lastName}
                        name="lastName"
                        onChange={handleFormInput}
                    />
                    {errors.lastName && <span className="error">{errors.lastName}</span>}
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 pt-3">
                    <label htmlFor={`companyURL${id}`} className="d-block">
                        {text[lang].webPage}
                    </label>
                    <input
                        aria-label={text[lang].webPage}
                        id={`companyURL${id}`}
                        type="text"
                        placeholder={text[lang].webPagePlaceholder}
                        value={formData.companyURL}
                        name="companyURL"
                        onChange={handleFormInput}
                    />
                    {errors.companyURL && <span className="error">{errors.companyURL}</span>}
                </div>
                <div className="col-sm-12 pt-3">
                    <label htmlFor={`phone${id}`} className="d-block">
                        {text[lang].phone}
                    </label>
                    <div className="country-phone-code">
                        <PhoneInput
                            aria-label={text[lang].phone}
                            inputProps={{
                                name: 'phone',
                                required: true,
                                autoFocus: true,
                                id: `phone${id}`,
                                autoFormat: true,
                            }}
                            placeholder={text[lang].phonePlaceholder}
                            value={formData.phone}
                            onChange={(val, country, e, formattedValue) =>
                                phoneOnChange(formattedValue, country)
                            }
                            disableCountryGuess
                        />
                    </div>
                    {errors.phone && <span className="error">{errors.phone}</span>}
                </div>
                <div className="col-sm-12 pt-3 checkbox">
                    <label htmlFor={`acceptEmails${id}`}>
                        <input
                            id={`acceptEmails${id}`}
                            type="checkbox"
                            value={formData.acceptEmails}
                            name="acceptEmails"
                            onChange={handleFormInput}
                        />
                        <span>{text[lang].acceptEmailText}</span>
                    </label>
                </div>
                <div className="col-sm-12 pt-3 checkbox">
                    <label htmlFor={`acceptWhatsApp${id}`}>
                        <input
                            id={`acceptWhatsApp${id}`}
                            type="checkbox"
                            value={formData.acceptWhatsApp}
                            name="acceptWhatsApp"
                            onChange={handleFormInput}
                        />
                        <span>{text[lang].acceptWhatsAppText}</span>
                    </label>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-sm-12 pt-3 d-flex justify-content-center">
                    <button
                        className="ow-button ow-button--small ow-button--rounded mt-5 mb-3 google-ads-form-conversion"
                        onClick={handleSubmit}
                        type="button"
                    >
                        {text[lang].signUp}
                    </button>
                </div>
                <div className="col-md-12 col-sm-12 pt-3">
                    {formMessage && <span className="ow-success-span">{formMessage}</span>}
                </div>
            </div>
        </div>
    )
}
export default ContactForm
